import React, { useEffect, useState } from "react";
import { Affix, Menu } from 'antd';
import { DownOutlined } from '@ant-design/icons';
import { getColor, getFontFamily } from "../utils/ConvertCSS";
import { useTemplate } from "../utils/Template";
import CSS from "../utils/CSS";
import { usePrefs } from "../utils/Prefs";
import { trimTrailingChar } from "../utils/Utils";
import conditional from "../utils/conditional";

export default function SiteNav(props) {

    const [prefs,] = usePrefs();
    const [template,] = useTemplate();
    const { open = false, mobile = false, page = { id: 0 }, setPage = () => { }, menus = [], globalTarget = false, containerRef = {}, setMobileMenu = () => { } } = props;

    const {
        container = true,
        data = {},
    } = prefs.nav_bar;

    const {
        text_colour = 0,
        text_preset = 0,
        background_colour = 0,
        selected_text_colour = 0,
        selected_background_colour = 0,
        letter_spacing = 0,
        // selected_background_animation = false,
        // selected_background_animation_style = "left-animation",
        // selected_background_animation_duration = 0.5,
        selected_underline = false,
        selected_underline_colour = 0,
        selected_underline_thickness = 2,
        selected_animation = false,
        selected_animation_style = "left-animation",
        selected_animation_duration = 0.5,
        transform = "none",
        spacing = 20,
        font_size = 14,
        pinned = true,
    } = data;

    const [loading, setLoading] = useState(spacing);
    const search_bar = prefs.search_bar || { data: { background_colour, text_colour } };
    let id = 0;
    useEffect(() => {
        setLoading(true);
        clearTimeout(id);
        id = setTimeout(() => {
            setLoading(false);
        }, 100)


    }, [spacing])

    let _class = ``;

    _class += `.animation {
        position: relative;
    }`;

    _class += `.animation::after {
        content: '';
        position: absolute;
        width: 100%;
        transform: scaleX(0);
        height: ${selected_underline_thickness}px;
        bottom: -2px;
        left: 0;
        background-color: ${getColor(selected_underline_colour, template, "#000")};
        ${selected_animation ? `transition: transform ${selected_animation_duration}s ease-out;` : ""};    
    }`

    _class += `.animation:hover::after, 
    .bm_nav .ant-menu.ant-menu-dark .ant-menu-item-selected .animation::after,
    .bm_nav .ant-menu.ant-menu-dark .ant-menu-item-active .animation::after { 
        transform: scaleX(1);
    }`;

    _class += `.animation.left-animation::after {
        transform-origin: bottom right;
    }`;

    _class += `.animation.left-animation:hover::after,
    .bm_nav .ant-menu.ant-menu-dark .ant-menu-item-selected .animation.left-animation::after,
    .bm_nav .ant-menu.ant-menu-dark .ant-menu-item-active .animation.left-animation::after {
        transform-origin: bottom left;
    }`;

    _class += `.animation.right-animation::after {
        transform-origin: bottom left;
    }`;

    _class += `.animation.right-animation:hover::after,
    .bm_nav .ant-menu.ant-menu-dark .ant-menu-item-selected .animation.right-animation::after,
    .bm_nav .ant-menu.ant-menu-dark .ant-menu-item-active .animation.right-animation::after  {
        transform-origin: bottom right;
    }`;

    _class += `.animation.center-animation::after {
        transform-origin: bottom center;
    }`;

    _class += `.animation.center-animation:hover::after,
    .bm_nav .ant-menu.ant-menu-dark .ant-menu-item-selected .animation.center-animation::after,
    .bm_nav .ant-menu.ant-menu-dark .ant-menu-item-active .animation.center-animation::after {
        transform-origin: bottom center;
    }`;

    _class += `
    .bm_nav, .bm_nav .ant-menu.ant-menu-dark, .bm_nav .ant-menu-item, .bm_nav .ant-menu-sub{
        color: ${getColor(text_colour, template, "#000")};
        font-family: '${getFontFamily(text_preset, template)}';
        text-transform : ${transform};
        font-size : ${font_size}px;
        background: transparent;
        letter-spacing: ${letter_spacing}px;
    }`;

    _class += `
    .bm_nav, .bm_nav .ant-menu.ant-menu-dark{
        background: ${getColor(background_colour, template, "#fff")};
    }`;

    _class += `
    .bm_nav .ant-menu-dark.ant-menu-horizontal > .ant-menu-item, .ant-menu-dark.ant-menu-horizontal > .ant-menu-submenu{
        padding: 0px ${spacing}px;
    }`;

    //hover, selected... 
    _class += `
    .bm_nav .ant-menu.ant-menu-dark .ant-menu-item-selected, .bm_nav .ant-menu.ant-menu-dark .ant-menu-submenu-title:hover, .bm_nav .ant-menu.ant-menu-dark .ant-menu-item-active, .bm_nav .ant-menu-submenu-active, .bm_nav .ant-menu-submenu-selected {
        background: ${getColor(selected_background_colour, template, "#000")} !important;
        color: ${getColor(selected_text_colour, template, "#fff")};
        transition:none;
    }`;

    // submenu 
    _class += `
    .bm_nav .ant-menu-vertical {
        background: ${getColor(background_colour, template, "#000")} !important;
        border-radius: 0px !important;
    }`;

    _class += `
    .bm_nav.ant-menu-dark.ant-menu-dark:not(.ant-menu-horizontal) .ant-menu-item {
        margin: 0px;
    }`;

    _class += `
    .bm_nav.ant-menu-dark.ant-menu-dark:not(.ant-menu-horizontal) .ant-menu-item-selected,  .bm_nav.ant-menu-dark.ant-menu-dark:not(.ant-menu-horizontal) .ant-menu-item:hover {
        background: ${getColor(selected_background_colour, template, "#000")} !important;
        color: ${getColor(selected_text_colour, template, "#fff")};
    }`;

    _class += `
    .ant-drawer-header{
        background: ${getColor(search_bar.data.background_colour, template, "#000")} !important;
        border-bottom: 1px solid ${getColor(search_bar.data.background_colour, template, "#000")} !important;
    }
    `

    _class += `
    .ant-drawer-header .ant-drawer-title{
        color : ${getColor(search_bar.data.text_colour, template, "#000")} !important;
    }
    `

    _class += `
    .ant-drawer-close{
        color : ${getColor(search_bar.data.text_colour, template, "#000")} !important;
    }
    `


    const { view = "desktop" } = props;


    const openLink = (_item) => {

        let link = "";
        if (_item.url) {
            if (_item.url.substr(0, 4) === "http") {
                link = _item.url;
            } else {
                link = trimTrailingChar(window.sitesettings.url, "/") + _item.url;
            }
        }

        if (link) { window.open(link, "_blank"); return; }

        setPage(_item)
    }

    const menuClick = (_item) => {
        if (_item.url) {
            openLink(_item);
        } else {
            setPage(_item);
        }
    }

    const drawMenuItem = (_item) => {
        return (<Menu.Item onClick={() => {menuClick(_item); setMobileMenu(false)}} className="menu" key={_item.id}>
            {(_item.visibility === "test" && <>*</>)}<span className={`${selected_underline ? `animation ${selected_animation_style}` : ""}`}>{_item.name}</span>
        </Menu.Item>)
    }

    const drawMenu = (_data) => {
        // loop through top level
        return _data.filter(all => !all.parent_id).map(tl => {

            // Hide hidden from nav
            if (tl.visibility === "hidden") {
                return;
            }

            // Hide test from nav while previewing 
            if (!open && tl.visibility === "test") {
                return;
            }

            let children;

            if (open) {
                // Hide test from sub-nav while previewing 
                children = _data.filter(mi => mi.visibility !== "hidden" && mi.parent_id === tl.id);
            }

            else {
                // Show test from sub-nav while editing 
                children = _data.filter(mi => mi.visibility === "visible" && mi.parent_id === tl.id);
            }

            if (children.length > 0) {
                // has children
                return (
                    <Menu.SubMenu className="menu" key={tl.id} title={<>{(tl.visibility === "test" && <>*</>)}{tl.name}&nbsp;<DownOutlined style={{ "fontSize": "10px", "marginRight": "-5px" }} /></>}  >
                        {children.map(child => {
                            if (child.visibility === "hidden") {
                                return;
                            }
                            return drawMenuItem(child);
                        })}
                    </Menu.SubMenu>
                )
            } else {
                // does not have children
                return drawMenuItem(tl);
            }
        })
    }

    if (view !== "desktop") {
        return (<></>)
    }


    const draw = () => {
        return (
            <>
                <CSS prepend html={_class} />
                <div id="bm_nav" className="bm_nav bm-render">
                    <div className="menubg hide-block" style={{ "maxWidth": "100%", "height": "46px" }}>
                        {(!loading &&
                            <Menu
                                selectedKeys={(globalTarget) ? [] : [(page.id) ? page.id.toString() : ""]}
                                className="bm_nav"
                                rootClassName="bm_nav"
                                subMenuOpenDelay={0}
                                forceSubMenuRender={true}
                                overflowedIndicator={<>More Menus</>}
                                triggerSubMenuAction={"hover"}
                                style={{ "maxWidth": (container) ? "1248px" : "100%", "margin": "0 auto", "minHeight": (mobile) ? "calc(100vh - 55px)" : "inherit" }}
                                mode={(mobile) ? "inline" : "horizontal"}
                                theme="dark"
                            >
                                {drawMenu(menus)}
                            </Menu>
                        )}
                        {(loading &&
                            <Menu
                                selectedKeys={(globalTarget) ? [] : [(page.id) ? page.id.toString() : ""]}
                                className="bm_nav"
                                rootClassName="bm_nav"
                                subMenuOpenDelay={0}
                                forceSubMenuRender={true}
                                overflowedIndicator={<>More Menus</>}
                                triggerSubMenuAction={"hover"}
                                style={{ "maxWidth": (container) ? "1248px" : "100%", "margin": "0 auto", "minHeight": (mobile) ? "calc(100vh - 55px)" : "inherit" }}
                                mode={(mobile) ? "inline" : "horizontal"}
                                theme="dark"
                            >
                                {drawMenu(menus)}
                            </Menu>
                        )}
                    </div>
                </div>
            </>
        );
    }

    const search = document.getElementById("search_bg");
    const search_bar_height = (prefs?.search_bar?.data?.pin_navigation) ? search.offsetHeight : 0;

    return (
        <div style={{ "position": "relative", "zIndex": "10" }}>
            <CSS html={_class} />
            <conditional.true value={(pinned)}>
                <Affix target={() => containerRef.current} offsetTop={search_bar_height}><div style={{"marginTop" : "0px"}}>{draw()}</div></Affix>
            </conditional.true>
            <conditional.true value={(!pinned)}>
                <div style={{ "marginTop": "0px" }}>{draw()}</div>
            </conditional.true>
        </div>

    )


}
